import { useAppContext } from './context';

export const GetFreeLabel = () => {
  const { merchantData } = useAppContext();
  const currency = merchantData.base_currency;

  return currency.symbol_first
    ? `${currency.alternate_symbol}0`
    : `0 ${currency.alternate_symbol}`;
};

// convert products currency to current
// from https://bitbucket.org/starlinglabs/shop.shoplineapp.com/src/7a9b040dd2a66f98672b81e242020bc3ffd6977a/app/javascript/packs/shop/app.js?at=master#lines-439
export function convertProductCurrency() {
  const currency =
    Currency.cookie.read() ||
    window.mainConfig.currencyData.requestCountryCurrencyCode;
  if (
    window.mainConfig.isMultiCurrencyEnabled &&
    currency != window.mainConfig.merchantData.base_currency_code
  ) {
    //replace all static price tag via selector
    Currency.convertAll(
      window.mainConfig.merchantData.base_currency_code,
      currency,
      '.price, .sl-price',
    );
  }
}
